// extracted by mini-css-extract-plugin
export default {"formHolder":"ModalCollection_formHolder__Hg4te","formfield":"ModalCollection_formfield__h6hVb","spinnerHolder":"ModalCollection_spinnerHolder__Pist+"};